<template>
  <div class="col-lg-2">
    SPH<br />
    <div class="py-1">
      <button class="btn btn-primary btn-sm" @click="downloadSPH" :disabled="isLoading">
        {{ isLoading ? "Loading..." : "Download" }}
        <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true" v-if="isLoading"></span>
      </button>
    </div>
  </div>
</template>

<script>
import swal from "sweetalert";

export default {
  name: "DownloadSPH",

  data() {
    return {
        isLoading: false,
    };
  },

  computed: {
    orderCode() {
      return this.$route.query.orderCode || "-";
    },
    orderId() {
      return this.$route.params.orderId;
    },
  },

  methods: {
    async downloadSPH() {
        this.isLoading = true;
      try {
        const response = await this.$http.get(
          `${process.env.DOWNLOAD_SPH_DOC}/${this.orderId}`,
          {
            headers: { "Asani-Token": localStorage.getItem("jwt") },
          }
        );
        if (response.data.status !== 200) {
          return swal(
            "Error",
            response.data.message || "Failed to download SPH document.",
            "error"
          );
        }
        const base64String = response.data.data;

        const byteCharacters = atob(base64String);
        const byteNumbers = new Array(byteCharacters.length);
        for (let i = 0; i < byteCharacters.length; i++) {
          byteNumbers[i] = byteCharacters.charCodeAt(i);
        }
        const byteArray = new Uint8Array(byteNumbers);
        const blob = new Blob([byteArray], { type: "application/vnd.openxmlformats-officedocument.wordprocessingml.document" });

        const url = window.URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", `SPH_${this.orderCode}.docx`);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
      } catch (error) {
        swal("Error", "Failed to download SPH document.", "error");
      } finally {
        this.isLoading = false;
      }
    },
  },
};
</script>


// WEBPACK FOOTER //
// src/components/Order/CustomComponent/Action/DownloadSPH.vue